import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Grid, withStyles } from '@material-ui/core'
import { Remove } from '@material-ui/icons'
import CardPaper from './CardPaper'
import { Label, PrimaryButton, SelectField, Loader } from '../default'
import { acGetAllFilters, acGetFilter, acGetFilteredUsers } from '../../class/actions'

function CardSearchFilter({
  classes,
  loadingFilters, filters
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [selectedFilter, setSelectedFilter] = useState('')
  const [filterError, setFilterError] = useState(false)

  const [appliedFilter, setAppliedFilter] = useState(null)
  const [filteredUsersQty, setFilteresUsersQty] = useState(0)

  useEffect(() => {
    if (!filters)
      dispatch(acGetAllFilters())
  }, [dispatch, filters])

  useEffect(() => {
    if (selectedFilter)
      setFilterError(false)

  }, [selectedFilter])

  const validateFilterBeforeSearch = () => {

    if (!selectedFilter) {
      setFilterError(true)
      return
    }

    dispatch(acGetFilter(selectedFilter))
      .then(filter => {
        setAppliedFilter(filter)
      })
      .catch(err => console.error(err))

    dispatch(acGetFilteredUsers(selectedFilter))
      .then(filteredUsers => {
        setFilteresUsersQty(filteredUsers.length)
      })

  }

  return (
    <CardPaper>
      <div className={classes.form}>
        {
          (loadingFilters || !filters) ?
            <Loader /> : (
              <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={10}>
                  <SelectField
                    label={t('panels.filters.title')}
                    items={filters.map(filter => ({
                      name: filter.name,
                      value: filter.filter_id
                    }))}
                    value={selectedFilter}
                    onChange={e => setSelectedFilter(e.target.value)}
                    error={filterError}
                  />
                </Grid>

                <Grid item xs={2}>
                  <PrimaryButton
                    onClick={validateFilterBeforeSearch}
                    style={{ width: '100%', height: '100%' }}
                  >
                    {t('cards.filters.btnFilter')}
                  </PrimaryButton>
                </Grid>

                <Grid item xs={9}>
                  <Label v='body1'>
                    {t('cards.filters.filterName')}
                  </Label>
                  <Label v='h6'>
                    {appliedFilter ? appliedFilter.name : <Remove />}
                  </Label>
                </Grid>

                <Grid item xs={3}>
                  <Label v='body1'>
                    {t('cards.filters.usersQuantity')}
                  </Label>
                  <Label v='h6'>
                    {filteredUsersQty}
                  </Label>
                </Grid>

                <Grid item xs={12}>
                  <Label v='body1'>
                    {t('cards.filters.filterDescription')}
                  </Label>
                  <Label v='body1' bold>
                    {appliedFilter ? appliedFilter.description : <Remove />}
                  </Label>
                </Grid>

              </Grid>
            )
        }
      </div>
    </CardPaper>

  )
}

CardSearchFilter.propTypes = {
  onSearch: PropTypes.func,
}

CardSearchFilter.defaultProps = {
  onSearch: () => true
}

const styles = theme => ({
  form: {
    display: 'flex',
    alignItems: 'center',
  }
})

const mapStateToProps = ({ ReducerFilter }) => ({
  loadingFilters: ReducerFilter.loadingFilters,
  filters: ReducerFilter.filters,
})

export default connect(mapStateToProps)(withStyles(styles)(CardSearchFilter))